import { render } from "./UserGrid.vue?vue&type=template&id=11fe5936"
import script from "./UserGrid.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserGrid.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script